/*eslint-disable*/
import React from "react";
import { Container } from "reactstrap";

const STATS = [
  {
    num: "50%",
    width: "50%",
    tone: "warm",
    claim: "of surveyed CEOs said rapid AI investment produced fragmented technology.",
    src: "IBM CEO Study, 2025",
    href: "https://newsroom.ibm.com/2025-05-06-ibm-study-ceos-double-down-on-ai-while-navigating-enterprise-hurdles",
  },
  {
    num: "68%",
    width: "68%",
    tone: "cool",
    claim: "consider integrated enterprise data architecture critical to getting there.",
    src: "IBM CEO Study, 2025",
    href: "https://newsroom.ibm.com/2025-05-06-ibm-study-ceos-double-down-on-ai-while-navigating-enterprise-hurdles",
  },
  {
    num: "23%",
    width: "23%",
    tone: "warm",
    claim: "of executives saw a favorable cost change from enterprise AI.",
    src: "McKinsey, Superagency in the Workplace",
    href: "https://www.mckinsey.com/capabilities/tech-and-ai/our-insights/superagency-in-the-workplace-empowering-people-to-unlock-ais-full-potential-at-work",
  },
];

function TheGap() {
  return (
    <section className="edge-gap-section" id="the-gap">
      <Container>
        <span className="edge-section-eyebrow">{"// THE PROBLEM"}</span>
        <h2 className="edge-section-heading">
          Everyone is spending.<br />
          <span className="muted">Almost no one can show the return.</span>
        </h2>

        <div className="edge-gap-grid">
          {STATS.map(s => (
            <div key={s.num + s.claim} className={`edge-gap-stat ${s.tone}`}>
              <span className="edge-gap-num">{s.num}</span>
              <p className="edge-gap-claim">{s.claim}</p>
              <div className="edge-gap-bar">
                <span style={{ width: s.width }} />
              </div>
              <a
                className="edge-gap-src"
                href={s.href}
                target="_blank"
                rel="noreferrer"
              >
                {s.src} ↗
              </a>
            </div>
          ))}
        </div>

        <p className="edge-gap-verdict">
          Our <em>FORGE</em> method is built for that gap. Every engagement ends with
          something running — and the number that proves it was worth building.
        </p>
      </Container>
    </section>
  );
}

export default TheGap;
